import React from 'react';
import { Redirect } from 'react-router-dom';
import { Modal } from '@gerdau/hefesto';
import { BpUnavailableModal } from '../../components/BpUnavailableModal';
import LoadingModal from '../../components/LoadingModal';
import { ShoppingCartBottomBar } from '../../components/Purchase/BottomBar';
import { PageWrapper, ContentArea } from './styles';
import { useFavorites } from './useFavorites';
import { useLoadingModal } from '../../context/useModaContext';
import FavoritesHeader from './FavoritesHeader';
import FavoritesSearchBar from './FavoritesSearchBar';
import FavoritesContent from './FavoritesContent';

const Favorites: React.FC = () => {
  const {
    userLoaded,
    isMVPUser,
    isUserAdmin,
    newSearchEmitterInputAdmin,
    loading,
    receiverLoading,
    customersLoading,
    bpError,
    customerName,
    emitterId,
    receiverId,
    emitterOptions,
    receiverOptions,
    isEmitterDisabled,
    isReceiverDisabled,
    handleSelectEmitter,
    handleSelectReceiver,
    searchCustomerById,
    allFavorites,
    displayedProducts,
    total,
    currentPage,
    pageSize,
    materialCode,
    setMaterialCode,
    searchInput,
    suggestions,
    searchRef,
    handleSelectSuggestion,
    handleSearch,
    handleClearSearch,
    handleKeyDown,
    handleSearchInputChange,
    handlePageChange,
    handleRemoveFavorite,
    showSearchAndFilters,
    paymentCondition,
    hasEmitterAndReceiver,
    submittedSearch,
    shouldShowModal,
    handleOrderModal,
    showBpUnavailableModal,
    onCloseBpUnavailableModal,
    hasOnlyCgCustomers
  } = useFavorites();
  const { shouldShowOnlyLoading } = useLoadingModal();

  if (userLoaded && (!isMVPUser || hasOnlyCgCustomers)) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <>
      {shouldShowModal &&
        !shouldShowOnlyLoading &&
        !loading &&
        !receiverLoading && (
          <Modal
            title="Continuar seu último pedido?"
            buttons={{
              left: {
                name: 'Novo pedido',
                children: 'Novo pedido',
                onClick: () => handleOrderModal('new')
              },
              right: {
                name: 'Continuar pedido',
                children: 'Continuar pedido',
                onClick: () => handleOrderModal('continuous')
              }
            }}
            modalSize="sm"
          >
            Você possui um pedido em andamento. Deseja continuar a partir dele?
          </Modal>
        )}
      <LoadingModal
        enabled={loading || receiverLoading}
        title="Aguarde alguns instantes"
        message="Carregando os dados..."
      />
      <PageWrapper>
        <FavoritesHeader
          emitterId={emitterId}
          receiverId={receiverId}
          emitterOptions={emitterOptions}
          receiverOptions={receiverOptions}
          isEmitterDisabled={isEmitterDisabled}
          isReceiverDisabled={isReceiverDisabled}
          handleSelectEmitter={handleSelectEmitter}
          handleSelectReceiver={handleSelectReceiver}
          isUserAdmin={isUserAdmin}
          newSearchEmitterInputAdmin={newSearchEmitterInputAdmin}
          onAdminSearch={searchCustomerById}
          customersLoading={customersLoading}
          bpError={bpError}
          customerName={customerName}
        />
        {showSearchAndFilters && (
          <FavoritesSearchBar
            searchInput={searchInput}
            suggestions={suggestions}
            searchRef={searchRef}
            paymentCondition={paymentCondition}
            materialCode={materialCode}
            submittedSearch={submittedSearch}
            total={total}
            setMaterialCode={setMaterialCode}
            handleSearch={handleSearch}
            handleClearSearch={handleClearSearch}
            handleKeyDown={handleKeyDown}
            handleSelectSuggestion={handleSelectSuggestion}
            handleSearchInputChange={handleSearchInputChange}
          />
        )}
        <ContentArea>
          <FavoritesContent
            hasEmitterAndReceiver={hasEmitterAndReceiver}
            loading={loading}
            submittedSearch={submittedSearch}
            displayedProducts={displayedProducts}
            allFavorites={allFavorites}
            total={total}
            currentPage={currentPage}
            materialCode={materialCode}
            emitterId={emitterId}
            receiverId={receiverId}
            pageSize={pageSize}
            handleRemoveFavorite={handleRemoveFavorite}
            handlePageChange={handlePageChange}
          />
        </ContentArea>
      </PageWrapper>
      <ShoppingCartBottomBar loading={loading} />
      {showBpUnavailableModal && (
        <BpUnavailableModal
          onCloseModal={onCloseBpUnavailableModal}
          title="Emissor não habilitado para favoritar produtos"
          message="O emissor selecionado não está habilitado para favoritar produtos. Apenas emissores habilitados para realizar compras na Gerdau mais podem adicionar produtos aos Favoritos."
        />
      )}
    </>
  );
};

export default Favorites;
